export const detectLeaveAdminIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete leave admin" || cleaned === "remove leave admin") {
        return { intent: "delete_leave_admin" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) leave admin/);
    if (deleteMatch) {
        return { intent: "delete_leave_admin", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create leave admin") || cleaned.includes("add leave admin")) {
        return { intent: "create_leave_admin" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create leave admin named (.+)/);
    if (createMatch) {
        return { intent: "create_leave_admin", name: createMatch[1].trim() };
    }

    return null;
};
